export class EmployeeMinimal {
  id = 0;

  fullName = '';

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export default EmployeeMinimal;
